import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { NavigationService } from '../core/services/components/navigation.service';
import { TokenService } from './services/token.service';

@Injectable({
  providedIn: 'root'
})

export class AuthorizatedGuard implements CanActivate {
  constructor(
     private storageService: TokenService,
    private navigation: NavigationService
  ) { }

  canActivate(_route: ActivatedRouteSnapshot) {
    const currentUser = this.storageService.getUserLoggedIn();
     if (currentUser != null && currentUser.token != null && currentUser.id > 0) {
				return true;
			} else {
				this.navigation.goToAuth();
				return false;
			}
 }
}
